/**
 * Created by fgallucci on 25/06/2020.
 */

// Webpack ejected projects support passing envs without REACT_APP

// override process env with runtime env if present
const ENV_CONTAINER = Object.freeze({
  ...process.env,
  ...(window.__RUNTIME_CONFIG__ || {})
})

const getEnv = (key, fallback) =>
  ENV_CONTAINER[`REACT_APP_${key}`] || ENV_CONTAINER[key] || fallback

export const BASE_URL = getEnv(
  'BASE_URL',
  `${window.location.origin}${window.location.pathname}api`
)

export const STORAGE_PREFIX = 'ublique:'

export const AUTH_ACCESS = {
  GRANTED: true,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403
}

export const LOCALSTORAGE_PREFERENCES_KEY = `${STORAGE_PREFIX}preferences`

export const I18N_REMOTE = true

export const I18N_DEFAULT = 'it-IT'

export const I18N_SUPPORTED_LANGUAGES = ['it-IT', 'en-GB', 'es-ES', 'ru-RU']

export const DEFAULT_NOTIFICATION_DURATION = 3500

export const DEFAULT_THEME = 'dark'

export const AUTH_TYPE = getEnv('AUTH_TYPE', 'base') // base | keycloak | keycloakOauth2

export const KEYCLOAK_APP_ID = getEnv('KEYCLOAK_APP_ID')

export const KEYCLOAK_URL = getEnv('KEYCLOAK_URL')

export const KEYCLOAK_REDIRECT_URL = getEnv('REDIRECT_URL')

export const KEYCLOAK_REALM = getEnv('KEYCLOAK_REALM', 'Ublique')
